exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-detail-unlimited-subscription .product-detail-unlimited-subscription-title{line-height:.8em}", ""]);

// exports
